// extracted by mini-css-extract-plugin
export default {"btns":"Song_btns__Oz3pk","btn":"Song_btn__QNSOe","active":"Song_active__UfB0A"};